import { toastReducer } from "./toastReducer"
import type { Action } from "../types/Action"
import type { State } from "../types/State"

const listeners: Array<(state: State) => void> = []
let memoryState: State = { toasts: [] }

/**
 * @group Functions
 * @summary <blockquote>Dispatch function for toast state management.</blockquote>
 * @example
 * ```tsx
 * dispatch({ type: "ADD_TOAST", toast: { id: "1", title: "Success" } });
 * ```
 */
function dispatch(action: Action) {
  memoryState = toastReducer(memoryState, action)
  listeners.forEach((listener) => {
    listener(memoryState)
  })
}

export { dispatch, listeners, memoryState } 